<template>
    <span class="text-danger">
        <i
            class="fa fa-trash fa-lg icon-button ml-2"
            title="Excluir Feriado"
            @click.stop="confirmarExcluir()"
            v-if="mostrarBtnExcluir"
        ></i>
    </span>
</template>

<script>
import FeriadosServicos from './FeriadosServicos'

export default {
    props: {
        feriado: {
            type: Object,
            default: () => ({})
        },
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluir() {
            this.$swal({
                title: 'Exclusão de Feriado',
                html: `Confirma a exclusão do feriado <b>${this.feriado.descricao}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluir()
                }
            })
        },

        excluir() {
            this.$store.dispatch('addRequest')
            FeriadosServicos.excluir(this.feriado.feriadoId)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Feriado excluído com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterFeriados')
                        } else {
                            this.$toast.error(
                                'Erro ao excluir feriado.',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnExcluir() {
            return this.$temAcessoView('ADMIN-FERIADOS-04')
        }
    }
}
</script>
